import axios from '../svgApi'

export default {
  getSvg: url => {
    return axios({
      url: url,
      method: 'get'
    })
  },
  /**
   * BannerDetail
   */
  getBannerDetailPage: pageUrl => {
    return axios({
      url: pageUrl,
      method: 'get'
    })
  }
}
